
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 14.3a1.1 1.1 0 100 2.2 1.1 1.1 0 000-2.2zm0-9.9a1.1 1.1 0 00-1.092.971L9.9 5.5v6.6a1.1 1.1 0 002.192.129l.008-.129V5.5A1.1 1.1 0 0011 4.4z","fill":"#F8BF1E"}})])
          )
        }
      }
    